var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLink(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#link_svg__clip0_183_11083)",
    stroke: "#3A3544",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.555 5.578l1.547-1.547a3.445 3.445 0 014.867 4.867l-2.211 2.204a3.43 3.43 0 01-4.86 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.445 14.422L8.898 15.97a3.445 3.445 0 01-4.867-4.867l2.211-2.203a3.43 3.43 0 014.86 0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "link_svg__clip0_183_11083"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h20v20H0z"
  })))));
}

export default SvgLink;